import React, {
    useEffect,
    useState,
} from 'react';

import { getTeamLogoUrl } from '~shared/utils/sportsbook';

export const useWidgetDimensions = (refElem) => {

    const element = ('current' in refElem) ? refElem.current : refElem;

    const [elemWidth, setWidth] = useState(element ? element.clientWidth : null);
    const [elemHeight, setHeight] = useState(element ? element.clientHeight : null);

    if (element) {
        if (elemWidth === null) {
            setWidth(element.clientWidth);
        }
        if (elemHeight === null) {
            setHeight(element.clientHeight);
        }
    }

    const updateWidthAndHeight = (elem) => {
        setWidth(elem[0].target.clientWidth);
        setHeight(elem[0].target.clientHeight);
    };

    useEffect(() => {
        let observer = null;
        if (element) {
            if (typeof ResizeObserver === 'function') {
                observer = new ResizeObserver(updateWidthAndHeight);
                observer.observe(element);
            }
        }

        return () => {
            if (element && observer) {
                observer.unobserve(element);
            }
        };
    }, []);

    return {
        elemWidth,
        elemHeight,
    };
};

export const displayCompetitors = event => {
    const {
        competitors,
        sport_slug: sportSlug,
        category_slug: categorySlug,
        isUsFormat = false,
        showTeamLogo,
    } = event;

    const compArr = Object.values(competitors);
    compArr.sort((compA, compB) => {
        return compA.order - compB.order;
    });

    if (isUsFormat) {
        compArr.reverse();
    }

    return (
        <div className="more-game-events-widget__events-competitors">
            {
                compArr.map((competitor, index) => {
                    const { slug: teamSlug, name } = competitor;
                    const logoUrl = showTeamLogo
                        ? getTeamLogoUrl(sportSlug, categorySlug, teamSlug)
                        : '';
                    const teamName = index === 0
                        ? `${name}${isUsFormat ? ' @' : ''}`
                        : name;

                    return <div key={index} className="more-game-events-widget__events-competitor">
                        {logoUrl && <img src={logoUrl} className="team-logo" />}
                        <span className="team-name">{teamName}</span>
                    </div>;
                })
            }
        </div>
    );
};
